import React, { useState } from "react";

import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import TableTemplate from "@components/Table/TableTemplate";
import { SCHOOLS_ENDPOINT } from "@constants/Endpoints";

import "./SchoolManagementPage.scss";

/**
 * SchoolManagementView component renders a table displaying school data.
 *
 * @param {Object} props - The component props.
 * @param {React.MutableRefObject} props.tableTemplateRef
 * @param {(schoolId) => void} props.onManageDeadlinesButtonClick
 * @param {Object} props.activeSchool
 */
export function SchoolManagementView(props) {
    const [t] = useTranslation();
    const [columns] = useState([
        {
            name: "name",
            headerCaption: t("Name"),
            size: "normal-x",
            canSort: true,
            canFilter: true,
            canEdit: false,
        },
        {
            name: "digiDeliveryId",
            headerCaption: t("DigiDeliveryID"),
            size: "large",
            canSort: true,
            canFilter: true,
            canEdit: false,
        },
        {
            name: "schoolDeliveryType",
            headerCaption: t("SchoolDeliveryType"),
            size: "normal-x",
            canSort: true,
            canFilter: true,
            canEdit: false,
        },
        {
            name: "schoolActiveNextYear",
            headerCaption: t("IsExitSchool"),
            textAlign: "center",
            size: "small",
            caption: (/** @type {School} */ x) => <input type="checkbox" checked={!x.schoolActiveNextYear} readOnly />,
            canSort: false,
            canFilter: true,
            canEdit: false,
        },
        {
            name: "actions",
            headerCaption: t("Actions"),
            textAlign: "center",
            size: "small",
            caption: (/** @type {School} */ x) => (
                <Button className="button" onClick={() => props.onManageDeadlinesButtonClick(x.id)}>
                    {t("Manage Deadlines")}
                </Button>
            ),
            canSort: false,
            canFilter: false,
            canEdit: false,
        },
    ]);

    return (
        <div className="school-management-page">
            <TableTemplate
                ref={props.tableTemplateRef}
                // @ts-ignore
                title={t("SchoolsManagement")}
                endpoint={SCHOOLS_ENDPOINT}
                columns={columns}
                uniqueId="id"
                paginator={true}
            />
        </div>
    );
}

export default SchoolManagementView;
